import * as THREE from 'three'
import Experience from '../Experience.js'
import { modeldata } from '../../motion-industries'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

export default class Fox {
    constructor(roughness, metalness, castShadow, recieveShadow) {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.time = this.experience.time
        this.debug = this.experience.debug
        this.camera = this.experience.camera
        this.mousedowned = false
        this.sizes = this.experience.sizes
        this.modeldata = modeldata['conway-machines']
        this.activeModel=null
        this.modelIsActive = null
        this.load = new GLTFLoader()
        this.loadBB = new GLTFLoader()

        this.raycaster = new THREE.Raycaster()

        this.rayOrigin = new THREE.Vector3(- 3, 0, 0)
        this.rayDirection = new THREE.Vector3(10, 0, 0)
        this.rayDirection.normalize()
        this.raycaster.set(this.rayOrigin, this.rayDirection)
        this.isClicked = false
        this.mouse = new THREE.Vector2()
        window.addEventListener('mousemove', (event) => {
            this.mouse.x = event.clientX / this.sizes.width * 2 - 1
            this.mouse.y = - (event.clientY / this.sizes.height) * 2 + 1


        })

        this.environmentMap = {}
        this.environmentMap.intensity = 1.5
        this.environmentMap.texture = this.resources.items.environmentMapTexture
        //(this.resources.items.environmentMapTexture);
        this.environmentMap.texture.colorSpace = THREE.SRGBColorSpace
        

        this.scene.environment = this.environmentMap.texture
        this.color = new THREE.Color('#ffffff')
        this.scene.background = this.color
        this.environmentMap.updateMaterials = () => {
            this.scene.traverse((child) => {
                if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial) {
                    if(child.name != "Cylinder001" && child.name!="M-SP116"){
                        console.log(child.name);
                    child.material.envMap = this.environmentMap.texture
                    child.material.envMapIntensity = this.environmentMap.intensity
                    child.frustumCulled = false
                    child.material.dispose()
                    child.geometry.dispose()
                    child.material.envMapIntensity = 1.6
                    child.material.needsUpdate = true
                    child.material.metalness=1
                    child.material.roughness = 0.4
                    child.recieveShadow=true
                    // child.castShadow=true
                }
                if(child.name=="M-SP116"){
                    child.material.envMapIntensity = 1.2
                    child.material.metalness=1
                    child.material.roughness = 0.4
                    child.material.needsUpdate = true

                }
                if(child.name == "Cylinder001"){
                    child.material.needsUpdate = true
                    child.material.envMapIntensity = 1.5
                    child.recieveShadow=true
                    // child.castShadow=true
                    child.material.roughness = 0.8
                }
            }
            })
        }
        
        this.environmentMap.updateMaterials()
        this.contextMenuDisplayed = false
        window.addEventListener("contextmenu", (event) => {

            event.preventDefault();
            if (this.scene.getObjectByName(this.activeModel) ) {
                if(!this.contextMenuDisplayed){

                this.checks = [this.lol, this.lols];
                this.mouse.x = event.clientX / this.sizes.width * 2 - 1;
                this.mouse.y = -(event.clientY / this.sizes.height) * 2 + 1;

                this.raycaster.setFromCamera(this.mouse, this.camera.instance);
                this.IntersectForContext = this.raycaster.intersectObject(this.scene.getObjectByName(this.activeModel),true );
                //(this.scene.children);
                //(this.checks);
                // Perform a raycast from the camera's perspective

                // Create the context menu only if an object is intersected
                if (this.IntersectForContext.length > 0) {
                    // Show a custom context menu with "Remove" and "Duplicate" options
                    const contextMenu = document.createElement("div");
                    contextMenu.className = "context-menu";
                    contextMenu.style.position = "absolute";
                    contextMenu.style.left = event.clientX + "px";
                    contextMenu.style.top = event.clientY + "px";

                    // Create "Remove" option
                    const removeOption = document.createElement("div");
                    removeOption.className = "context-menu-button";
                    removeOption.innerText = "Remove";

                    removeOption.addEventListener("click", () => {
                        //(this.IntersectForContext[0].object.parent);
                        this.scene.remove(this.IntersectForContext[0].object.parent)
                        document.body.removeChild(contextMenu)
                        this.contextMenuDisplayed = false; // Reset the flag
                    });
                    
                    // Create "Duplicate" option
                    // const duplicateOption = document.createElement("div");
                    // duplicateOption.className = "context-menu-button";
                    // duplicateOption.innerText = "Duplicate";
                    // duplicateOption.addEventListener("click", () => {
                    //     if (this.IntersectForContext.length > 0) {
                    //         if (this.IntersectForContext[0].object.parent == (this.scene.getObjectByName(this.activeModel))) {
                    //             this.scene.remove(this.scene.getObjectByName(this.modelIsActive))
                    //             this.clonedLol = (this.scene.getObjectByName(this.activeModel)).clone()
                    //             this.clonedLol.position.set(-4, 0, 0)
                    //             this.clonedLol.rotation.set(-Math.PI / 2, 0, 0)
                    //             this.scene.add(this.clonedLol)
                    //         }
                           

                    //     }

                        // document.body.removeChild(contextMenu);

                        // this.contextMenuDisplayed = false; // Reset the flag
                       
                    // });

                    contextMenu.appendChild(removeOption);
                    // contextMenu.appendChild(duplicateOption);
                    // if (this.IntersectForContext[0].object.parent == this.lols) {
                    //     this.scene.remove(this.scene.getObjectByName(this.activeModel))
                    //     this.clonedLols = this.lols.clone()
                    //     this.clonedLols.position.set(4, 0, 0)
                    //     this.clonedLols.rotation.set(-Math.PI / 2, -Math.PI, 0)

                    //     this.scene.add(this.clonedLols)
                    // }
                    document.body.appendChild(contextMenu);
                    this.contextMenuDisplayed = true; // Set the flag to indicate context menu is displayed
                }

            }
            document.addEventListener("click", () => {
                if (this.contextMenuDisplayed) {
                    // Check if the context menu is displayed
                    // If it is, remove it
                    const contextMenu = document.querySelector(".context-menu");
                    if (contextMenu) {
                        document.body.removeChild(contextMenu);
                    }
                    this.contextMenuDisplayed = false; // Reset the flag
                }

                })
            


        }
        if (this.scene.getObjectByName(this.modelIsActive) ) {
            if(!this.contextMenuDisplayed){

            this.checks = [this.lol, this.lols];
            this.mouse.x = event.clientX / this.sizes.width * 2 - 1;
            this.mouse.y = -(event.clientY / this.sizes.height) * 2 + 1;

            this.raycaster.setFromCamera(this.mouse, this.camera.instance);
            this.IntersectForContext = this.raycaster.intersectObject(this.scene.getObjectByName(this.modelIsActive),true );
            //(this.scene.children);
            //(this.checks);
            // Perform a raycast from the camera's perspective

            // Create the context menu only if an object is intersected
            if (this.IntersectForContext.length > 0) {
                // Show a custom context menu with "Remove" and "Duplicate" options
                const contextMenu = document.createElement("div");
                contextMenu.className = "context-menu";
                contextMenu.style.position = "absolute";
                contextMenu.style.left = event.clientX + "px";
                contextMenu.style.top = event.clientY + "px";

                // Create "Remove" option
                const removeOption = document.createElement("div");
                removeOption.className = "context-menu-button";
                removeOption.innerText = "Remove";

                removeOption.addEventListener("click", () => {
                    //(this.IntersectForContext[0].object.parent);
                    this.scene.remove(this.IntersectForContext[0].object.parent)
                    document.body.removeChild(contextMenu)
                    this.contextMenuDisplayed = false; // Reset the flag
                });

                // Create "Duplicate" option
              
                

                contextMenu.appendChild(removeOption);
              
                document.body.appendChild(contextMenu);
                this.contextMenuDisplayed = true; // Set the flag to indicate context menu is displayed
            }

        }
        
        document.addEventListener("click", () => {
            if (this.contextMenuDisplayed) {
                // Check if the context menu is displayed
                // If it is, remove it
                const contextMenu = document.querySelector(".context-menu");
                if (contextMenu) {
                    document.body.removeChild(contextMenu);
                }
                this.contextMenuDisplayed = false; // Reset the flag
            }

            })

    }


        });


        this.mousedown = false;
        let intersectionPoint = new THREE.Vector3();

        // document.getElementById("drag-button-1").addEventListener("mousedown", (event) => {
        //     // this.mousedown=true
        //     // this.markerMesh.visible=true
        //     // this.scene.add(this.markerMesh)
        //     // this.Marked = true
        //     // this.mouse.x = event.clientX / this.sizes.width * 2 - 1
        //     // this.mouse.y = - (event.clientY / this.sizes.height) * 2 + 1
        //     // this.raycaster.setFromCamera(this.mouse,this.camera.instance)
        //     // this.intersect = this.raycaster.intersectObjects(this.scene.children)
        //     // if(this.lols){

        //     //     if(this.intersect.length>0){
        //     // this.scene.add(this.lols)

        //     //         this.intersectPoint = this.intersect[0].point
        //     //     this.lols.position.copy(intersectionPoint);

        //     //     }
        //     //     //(this.lols);


        //     // }


        // })


        // window.addEventListener("mousemove", (event) => {
        //     if (this.lols) {
        //         if (this.mousedown) {

        //             this.mouse.x = (event.clientX / this.sizes.width) * 2 - 1;
        //             this.mouse.y = -((event.clientY / this.sizes.height) * 2 - 1);
        //             this.raycaster.setFromCamera(this.mouse, this.camera.instance);
        //             this.intersect = this.raycaster.intersectObjects(this.scene.children);

        //             if (this.intersect.length > 0 && this.markerMesh) {
        //                 intersectionPoint.copy(this.intersect[0].point);
        //                 this.intersectPoint = this.intersect[0].point;
        //                 this.lols.position.copy(this.intersectPoint);
        //             }
        //         }
        //     }

        // });
        this.Marked = false
        this.Marker = false
        this.isDragging = false

        // window.addEventListener("mousemove", (event) => {
        //     if (this.lols && this.markerMesh) {
        //         if (this.mousedown) {
        //             this.isDragging = true
        //             this.mouse.x = (event.clientX / this.sizes.width) * 2 - 1;
        //             this.mouse.y = -((event.clientY / this.sizes.height) * 2 - 1);
        //             this.raycaster.setFromCamera(this.mouse, this.camera.instance);
        //             this.intersect = this.raycaster.intersectObject(this.markerMesh, true);

        //             if (this.intersect.length > 0) {
        //                 //(this.intersect);
        //                 intersectionPoint.copy(this.intersect[0].point);
        //                 this.intersectPoint = this.intersect[0].point;
        //                 this.lols.position.copy(this.markerMesh.position);
        //                 this.Marked = true

        //             }
        //             else {
        //                 this.Marked = false
        //             }

        //             if (this.clonedLol) {
        //                 this.scene.remove(this.clonedLol)

        //             }

        //         }
        //     }

        // });

        // document.addEventListener("mouseup", (event) => {
        //     this.mousedown = false;
        //     this.markerMesh.visible = false
        //     this.scene.remove(this.markerMesh)
        //     if (this.Marked == false) {
        //         this.scene.remove(this.lols)


        //     }





        // });
        // this.mousedowned = false
        // document.getElementById("drag-button-3").addEventListener("mousedown", (event) => {
        //     this.mousedowned = true
        //     this.markerMeshs.visible = true
        //     this.scene.add(this.markerMeshs)
        //     this.mouse.x = event.clientX / this.sizes.width * 2 - 1
        //     this.mouse.y = - (event.clientY / this.sizes.height) * 2 + 1
        //     this.raycaster.setFromCamera(this.mouse, this.camera.instance)
        //     this.intersect = this.raycaster.intersectObjects(this.scene.children)
        //     if (this.lol) {

        //         if (this.intersect.length > 0) {
        //             this.scene.add(this.lol)

        //             this.intersectPoint = this.intersect[0].point
        //             this.lol.position.copy(this.intersectPoint)
        //         }
        //         //(this.lol);


        //     }


        // })







        // window.addEventListener('pointermove',()=>{
        //     this.raycaster.setFromCamera(this.mouse, this.camera.instance)
        //     if (this.isClicked == false && !this.isDraggingOrClicking) {
        //         var intersects = this.raycaster.intersectObjects(this.model.children, true);
        //         for (this.n = 0; this.n < this.modeldata.length; this.n++) {
        //             if (intersects[0] && intersects[0].object.name.startsWith(this.modeldata[this.n].rgb)) {

        //                 document.body.style.cursor = "pointer"

        //             }
        //             else {
        //                 if (intersects[0] != null) {
        //                     if (this.modeldata.includes(intersects[0].object.material.name)) {

        //                     }
        //                     this.model.traverse(function (child) {
        //                         if (intersects[0] != null && child.material instanceof THREE.MeshStandardMaterial && child.material.name != intersects[0].object.material.name) {
        //                             // child.material.emissive.set("#000000")
        //                             child.material.opacity = 1
        //                             child.visible = true


        //                         }

        //                     })

        //                 }
        //                 else {

        //                     this.model.traverse(function (child) {
        //                         if (child.material instanceof THREE.MeshStandardMaterial) {
        //                             // child.material.emissive.set("#000000")
        //                             child.material.opacity = 1
        //                             // child.material.transparent = true
        //                             // document.body.style.cursor = "grab"


        //                         }
        //                     })


        //                 }
        //             }
        //         }
        //     }
        // })
        this.loadBox()
        this.environmentMap.updateMaterials()

        // Debug
        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder('fox')
        }

        window.addEventListener('message', (event) => {
            if (event.data.event == "hideConnector") {
                while (document.getElementById("buttons").firstChild) {
                    document.getElementById("buttons").removeChild(document.getElementById("buttons").firstChild);
                }
            }
            if (event.data.event == "showConnectorA") {
                //(event.data.url);
                while (document.getElementById("buttons").firstChild) {
                    document.getElementById("buttons").removeChild(document.getElementById("buttons").firstChild);
                }
                for (let i = 0; i < event.data.url.length; i++) {
                    const urlItem = event.data.url[i];
                    const button = document.createElement('button');
                    button.style.backgroundImage = `url(${urlItem.url})`;
                    // button.textContent = urlItem.text;
                    button.style.backgroundRepeat = 'no-repeat';
                    button.style.backgroundPosition = 'center';
                    button.style.backgroundSize = 'cover';
                    button.style.height = '8rem';
                    button.style.width = '8rem';
                    button.style.position = 'relative';
                    button.style.marginLeft = '3rem';
                    const buttonText = document.createElement('div');
                    buttonText.classList.add('button-text');
                    buttonText.textContent = urlItem.text;
                    button.append(buttonText)
                    this.loadModelar(urlItem.value, urlItem.model)
                    button.setAttribute('model',urlItem.model)
                    button.setAttribute('marker',urlItem.value)
                    button.addEventListener('mousedown', event => {
                    this.environmentMap.updateMaterials()

                        if(this.scene.getObjectByName(this.modelIsActive)){
                            console.log(this.modelIsActive);
                            this.scene.getObjectByName(this.modelIsActive).visible=false
                            if(this.clonedLol){
                                this.scene.remove(this.clonedLol)
                            }
                        }
                        this.modelIsActive = event.target.getAttribute('model')
                        

                        let connectorA = {
                            "event": "ConnectorAValue",
                            "value": urlItem.value
                        }
                        if (window.parent) {
                            window.parent.postMessage(connectorA, "*")
                        }
                     
                        this.mousedown = true
                        this.scene.getObjectByName(button.getAttribute("marker")).visible = true
                        // this.scene.add(this.markerMesh)
                        this.mouse.x = event.clientX / this.sizes.width * 2 - 1
                        this.mouse.y = - (event.clientY / this.sizes.height) * 2 + 1
                        this.raycaster.setFromCamera(this.mouse, this.camera.instance)
                        this.intersect = this.raycaster.intersectObjects(this.scene.children)
                        if (this.scene.getObjectByName(this.modelIsActive)) {

                            if (this.intersect.length > 0) {


                                this.scene.getObjectByName(this.modelIsActive).visible = true
                                this.intersectPoint = this.intersect[0].point
                                this.scene.getObjectByName(this.modelIsActive).position.copy(this.intersectPoint);
                            }
                            //(this.lols);


                        }


                    })
                    window.addEventListener("mousemove", (event) => {

                        if (this.scene.getObjectByName(this.modelIsActive)) {

                            //("usao");
                            if (this.mousedown) {
                                this.mouse.x = (event.clientX / this.sizes.width) * 2 - 1;
                                this.mouse.y = -((event.clientY / this.sizes.height) * 2 - 1);
                                this.raycaster.setFromCamera(this.mouse, this.camera.instance);
                                this.intersect = this.raycaster.intersectObjects(this.scene.children);

                                if (this.intersect.length > 0  && this.scene.getObjectByName(button.getAttribute('model'))) {
                                    intersectionPoint.copy(this.intersect[0].point);
                                    this.intersectPoint = this.intersect[0].point;
                                    this.scene.getObjectByName(this.modelIsActive).position.copy(this.intersectPoint);
                                }
                            }
                        }

                    });

                    window.addEventListener("mousemove", (event) => {
                     
                        if (this.scene.getObjectByName(this.modelIsActive) && this.scene.getObjectByName(button.getAttribute('marker'))) {
                        if (this.mousedown) {

                                this.mouse.x = (event.clientX / this.sizes.width) * 2 - 1;
                                this.mouse.y = -((event.clientY / this.sizes.height) * 2 - 1);
                                this.raycaster.setFromCamera(this.mouse, this.camera.instance);
                                this.intersect = this.raycaster.intersectObject(this.markerMesh, true);

                                if (this.intersect.length > 0 && this.markerMesh) {
                                    this.scene.getObjectByName(this.modelIsActive).position.copy(this.scene.getObjectByName(button.getAttribute("marker")).position);
                                    this.Marked = true


                                }
                                else {
                                    this.Marked = false
                                }

                                if (this.clonedLols) {
                                    this.scene.remove(this.clonedLols)

                                }

                            }
                        }

                    });


                    document.addEventListener("mouseup", (event) => {
                        this.mousedown = false;
                        if (this.scene.getObjectByName(button.getAttribute("marker"))) {
                            this.scene.getObjectByName(button.getAttribute("marker")).visible = false
                        }
                        if (this.Marked == false && this.scene.getObjectByName(button.getAttribute("model")) ) {
                    this.scene.getObjectByName(button.getAttribute("model")).visible = false
                            if(this.clonedLol){
                                this.scene.remove(this.clonedLol)
                            }
                         


                        }

                    });

                    document.getElementById("buttons").appendChild(button)
                }
            }
            if (event.data.event == "showConnectorB") {
                //(event.data.url);
                while (document.getElementById("buttons").firstChild) {
                    document.getElementById("buttons").removeChild(document.getElementById("buttons").firstChild);
                }
                for (let i = 0; i < event.data.url.length; i++) {
                    const urlItem = event.data.url[i];
                    const button = document.createElement('button');
                    button.style.backgroundImage = `url(${urlItem.url})`;
                    // button.textContent = urlItem.text;
                    button.style.backgroundRepeat = 'no-repeat';
                    button.style.backgroundPosition = 'center';
                    button.style.backgroundSize = 'cover';
                    button.style.height = '8rem';
                    button.style.width = '8rem';
                    button.style.position = 'relative';
                    button.style.marginLeft = '3rem';
                    const buttonText = document.createElement('div');
                    buttonText.classList.add('button-text');
                    buttonText.textContent = urlItem.text;
                    button.append(buttonText)
                    button.setAttribute('modelLink',urlItem.url)
                    button.setAttribute('markerLink',urlItem.text)

                    this.loadModel(urlItem.text, urlItem.model, urlItem.url)
                    button.addEventListener('mousedown', event => {
                    this.environmentMap.updateMaterials()

                        if(this.scene.getObjectByName(this.activeModel)){
                            this.scene.getObjectByName(this.activeModel).visible=false

                        }
                        this.activeModel=event.target.getAttribute('modelLink')

                        let connectorB = {
                            "event": "ConnectorBValue",
                            "value": urlItem.value
                        }
                        if (window.parent) {
                            window.parent.postMessage(connectorB, "*")
                        }

                        this.mousedowned = true
                        this.scene.getObjectByName(button.getAttribute("markerLink")).visible = true
                        // this.scene.add(this.markerMesh)
                        this.mouse.x = event.clientX / this.sizes.width * 2 - 1
                        this.mouse.y = - (event.clientY / this.sizes.height) * 2 + 1
                        this.raycaster.setFromCamera(this.mouse, this.camera.instance)
                        this.intersect = this.raycaster.intersectObjects(this.scene.children)
                        if (this.scene.getObjectByName(this.activeModel)) {

                            if (this.intersect.length > 0) {


                                this.scene.getObjectByName(this.activeModel).visible = true
                                this.intersectPoint = this.intersect[0].point
                                this.scene.getObjectByName(this.activeModel).position.copy(this.intersectPoint);
                            }
                            //(this.lols);


                        }


                    })
                    window.addEventListener("mousemove", (event) => {

                        if (this.scene.getObjectByName(this.activeModel)) {

                            //("usao");
                            if (this.mousedowned) {
                                this.mouse.x = (event.clientX / this.sizes.width) * 2 - 1;
                                this.mouse.y = -((event.clientY / this.sizes.height) * 2 - 1);
                                this.raycaster.setFromCamera(this.mouse, this.camera.instance);
                                this.intersect = this.raycaster.intersectObjects(this.scene.children);

                                if (this.intersect.length > 0  && this.scene.getObjectByName(button.getAttribute('modelLink'))) {
                                    intersectionPoint.copy(this.intersect[0].point);
                                    this.intersectPoint = this.intersect[0].point;
                                    this.scene.getObjectByName(this.activeModel).position.copy(this.intersectPoint);
                                }
                            }
                        }

                    });

                    window.addEventListener("mousemove", (event) => {
                     
                        if (this.scene.getObjectByName(this.activeModel) && this.scene.getObjectByName(button.getAttribute('markerLink'))) {
                        if (this.mousedowned) {

                                this.mouse.x = (event.clientX / this.sizes.width) * 2 - 1;
                                this.mouse.y = -((event.clientY / this.sizes.height) * 2 - 1);
                                this.raycaster.setFromCamera(this.mouse, this.camera.instance);
                                this.intersect = this.raycaster.intersectObject(this.markerMeshs, true);

                                if (this.intersect.length > 0 && this.markerMeshs) {
                                    this.scene.getObjectByName(this.activeModel).position.copy(this.scene.getObjectByName(button.getAttribute("markerLink")).position);
                                    this.Marker = true


                                }
                                else {
                                    this.Marker = false
                                }

                                if (this.clonedLols) {
                                    this.scene.remove(this.clonedLols)

                                }

                            }
                        }

                    });


                    document.addEventListener("mouseup", (event) => {
                        this.mousedowned = false;
                        if (this.scene.getObjectByName(button.getAttribute("markerLink"))) {
                            this.scene.getObjectByName(button.getAttribute("markerLink")).visible = false
                        }
                        if (this.Marker == false && this.scene.getObjectByName(button.getAttribute('modelLink'))) {
                          this.scene.getObjectByName(button.getAttribute("modelLink")).visible = false
                         


                        }

                    });
                    document.getElementById("buttons").appendChild(button)


                }
            }
        }, false)


        // Resource
        this.resource = this.resources.items.object
        this.setModel()
        this.setAnimation()
        this.setScale()
        // this.loadModel()
        // this.loadModelar()
       

    }

    setModel() {
        this.model = this.resource.scene
        this.scene.add(this.model)
        this.model.visible = true
        this.model.name = "cable"
        //(this.model);
        this.model.traverse((child) => {
            if (child instanceof THREE.Mesh) {

                // child.castShadow = true
                child.frustumCulled = false
                child.material.dispose()
                child.geometry.dispose()

                child.material.needsUpdate = true
                // child.castShadow = true
                child.receiveShadow = true
            }
        })

    }

    
    setScale() {
        this.mat = new THREE.MeshLambertMaterial({
            color: 0xff0000
        });
        this.boxGeom = new THREE.BoxGeometry(1, 1, 1);




        this.model.scale.set(5, 5, 5)
        this.model.position.set(0, 0, 0)
        this.model.rotation.x = -Math.PI * 0.5
        // this.model.castShadow=true
        this.scene.add(this.model)
        //(this.model);

        const bbox = new THREE.Box3().setFromObject(this.model);

        // Calculate the center position and size of the bounding box
        const center = new THREE.Vector3();
        const size = new THREE.Vector3();
        bbox.getCenter(center);
        bbox.getSize(size);

        const planeHeight = bbox.min.y // Adjust the value as needed
        // Calculate the maximum dimension of the bounding box
        const maxDimension = Math.max(size.x, size.y, size.z);
        const box = new THREE.BoxHelper(this.model, 0xffff00);
        // this.scene.add( box );
        // Calculate the distance from the camera to fit the bounding box within the screen
        const distance = maxDimension / (2 * Math.tan(THREE.MathUtils.degToRad(this.camera.instance.fov) / 2));
        // Set the camera position and target based on the bounding box
        const cameraPosition = new THREE.Vector3();
        cameraPosition.x += (distance / 1);
        cameraPosition.y += (distance / 1);
        cameraPosition.z += (distance / 1);
        this.camera.instance.position.copy(cameraPosition);
        this.camera.instance.lookAt(center);
        this.camera.controls.target.copy(center);
        this.bbox = new THREE.Box3().setFromObject(this.model);



        //         this.model.rotation.set(0,0,0)
        //         // gsap.to(camera.position, {
        //     duration:0,
        //     x: center.x-7,
        //     y: center.y+5,
        //     z: center.z+10,
        //     onUpdate: function () {
        //         // //("Zooom je trenutno:"+camera.zoom);
        //         camera.updateProjectionMatrix()

        //     }
        // });

    }
    setAnimation() {
        this.animation = {}

        // Mixer
        this.animation.mixer = new THREE.AnimationMixer(this.model)

        // Actions
        this.animation.actions = {}


        this.animation.play = (name) => {
            const newAction = this.animation.actions[name]
            const oldAction = this.animation.actions.current

            newAction.reset()
            newAction.play()
            newAction.crossFadeFrom(oldAction, 1)

            this.animation.actions.current = newAction
        }

        // Debug
        if (this.debug.active) {
            const debugObject = {
                playIdle: () => { this.animation.play('idle') },
                playWalking: () => { this.animation.play('walking') },
                playRunning: () => { this.animation.play('running') }
            }
            this.debugFolder.add(debugObject, 'playIdle')
            this.debugFolder.add(debugObject, 'playWalking')
            this.debugFolder.add(debugObject, 'playRunning')
        }
    }

    update() {




        this.animation.mixer.update(this.time.delta * 0.001)
    }
    loadModel(marker2Name, pathForFile, lolName) {
        this.load.load(pathForFile, (gltf) => {


            this.lol = gltf.scene
            this.lol.scale.set(5, 5, 5)
            this.lol.rotation.x = -Math.PI / 2
            this.lol.rotation.y = -Math.PI
            this.geometryClone = this.lol.children[0].geometry.clone()
            this.marker = new THREE.MeshStandardMaterial({ color: "#0f0", transparent: true, opacity: 0.5 });
            this.markerMeshs = this.lol.clone()
            this.markerMeshs.position.set(this.bbox.max.x, 0, 0)
            this.markerMeshs.children[0].material = this.marker
            this.markerMeshs.visible = false
            this.markerMeshs.name = marker2Name
            this.lol.name = lolName
            this.scene.add(this.lol)


            this.lol.visible = false
            this.scene.add(this.markerMeshs)


        })



    }
    loadModelar(markerName, pathFile) {
        this.load.load(pathFile, (gltf) => {


            this.lols = gltf.scene
            this.lols.scale.set(5, 5, 5)

            this.lols.rotation.x = -Math.PI / 2


            //(this.lols.children[0].children[0]);
            this.geometryClone = this.lols.children[0].geometry.clone()
            this.marker = new THREE.MeshStandardMaterial({ color: "#0f0", transparent: true, opacity: 0.5 });
            this.markerMesh = this.lols.clone()
            this.markerMesh.position.set(this.bbox.min.x, 0, 0)
            this.markerMesh.children[0].material = this.marker
            this.markerMesh.visible = false
            this.markerMesh.name = markerName
            //(this.markerMesh.material);
            this.scene.add(this.markerMesh)
            //(this.experience.environment);
            this.scene.add(this.lols)
            this.lols.name = pathFile
            this.lols.visible = false



        })



    }
    loadBox() {
        this.loadBB.load("https://viewer-dev.zipcpq.com/models/ConwayMachine/kockica.glb", (gltf) => {


            this.box = gltf.scene
            this.box.scale.set(5,5,5)

            this.scene.add(this.box)
            this.box.children[0].material = new THREE.ShadowMaterial({
                opacity: 0.3,
                transparent: true,
                color: "f0f0f0"
            })





        })

    }

}